import BasePolicy from '@/policies/BasePolicy.js';

const hasPermission = (user, permission) => user.hasPermissionTo(permission) || user.hasGroupPermissionTo(permission);

/**
 * Frontend gate for RemediationProcess rows on the remediations dashboard.
 *
 * EdverumTableOrm calls `delete` and `update` with model class
 * "RemediationProcess" for every checked row. This policy must be registered
 * under that name; otherwise Gate.allows logs a missing-policy error and
 * returns false. `before` does not inherit the admin bypass, because these
 * rows are not bulk-deleted from the table and that bypass would surface a
 * Remove control. The API policy remains the authority for every action.
 */
export default class RemediationProcessPolicy extends BasePolicy {
    before() {
        return null;
    }

    viewAny(user) {
        return hasPermission(user, 'view a remediation process');
    }

    create(user) {
        return hasPermission(user, 'create a remediation process');
    }

    pass(user) {
        return hasPermission(user, 'pass a remediation');
    }

    reset(user) {
        return user.hasPermissionTo('reset a remediation');
    }

    update() {
        return false;
    }

    delete() {
        return false;
    }
}
